import React, { Children, cloneElement, useState, useEffect } from "react";
import PropTypes from "prop-types";

const IconRadioGroup = ({ value, onChange, children }) => {
  const [selectedVal, setSelectedVal] = useState(value);

  const handleChange = id => {
    setSelectedVal(id);
    onChange(id);
  };

  useEffect(() => {
    setSelectedVal(value);
  }, [value]);

  return (
    <div>
      {Children.toArray(children)
        .filter(child => child != null)
        .map((child) => {
          return cloneElement(child, {
            ...child.props,
            selected: selectedVal === child.props.id,
            onClick: handleChange,
          });
        })}
    </div>
  );
};

IconRadioGroup.propTypes = {
  /**
   * Valor del seleccionado
   */
  value: PropTypes.string,
  /**
   * Callback que se dispara con el cambio del elemento seleccionado
   */
  onChange: PropTypes.func,
};

export default IconRadioGroup;
